import {patchState, signalStore, withComputed, withMethods, withProps, withState} from '@ngrx/signals';
import {removeAllEntities, removeEntity, setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {Animal} from 'src/app/infrastructure/moovement-api/models/asset';
import {DeviceAssociationStore} from 'src/app/domain/devices/device-association.store';
import {computed, inject} from '@angular/core';

const initialState = {
  loading: true
};

export const AnimalsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<Animal>(),
  withProps(() => ({
    deviceAssociationStore: inject(DeviceAssociationStore)
  })),
  withMethods((store) => ({
    setAllEntities(animals: Animal[]) {
      patchState(store, setAllEntities(animals), { loading: false });
    },
    setEntity(animal: Animal) {
      patchState(store, setEntity(animal))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    },
    reset() {
      patchState(store, removeAllEntities(), initialState);
    }
  })),
  withComputed(({ deviceAssociationStore, entities, entityMap }) => ({
    deviceIdToAnimal: computed(() => {
      const result = new Map<string, Animal>();
      deviceAssociationStore.entities().forEach(deviceAssociation => {
        if (deviceAssociation.endDateTime) return;

        const assetId = deviceAssociation.assetId;
        if (!assetId) return;

        const animal = entityMap()[assetId];
        if (!animal) return;

        result.set(deviceAssociation.deviceId, animal);
      });

      return result;
    }),
    animalIdToDeviceId: computed(() => {
      const result = new Map<string, string>();
      deviceAssociationStore.entities().forEach(deviceAssociation => {
        if (deviceAssociation.endDateTime) return;

        const assetId = deviceAssociation.assetId;

        const animal = entityMap()[assetId];
        if (!animal) return;

        result.set(assetId, deviceAssociation.deviceId);
      });

      return result;
    }),
    unassignedAnimals: computed(() => {
      return entities().filter(animal => animal.assignedPaddockId == undefined);
    })
  }))
);
